var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{key:Math.random(),staticClass:"icon",on:{"click":function($event){return _vm.$emit('click')}}},[_c('svg',{class:[{ 'icon-animation-pulse': !_vm.exists }, _vm.classes, 'feather'],style:({
      height: `${_vm.size}em`,
      width: `${_vm.size}em`,
    }),attrs:{"xmlns":"http://www.w3.org/2000/svg","data-name":_vm.icon,"viewBox":"0 0 24 24","stroke":"currentColor","stroke-linecap":_vm.cap,"stroke-linejoin":_vm.join,"stroke-width":_vm.width,"fill":"none","role":"img","aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }